module.exports = __webpack_public_path__ + "img/icon.6a68540b.png";